import { useApp } from '../App';
import { useI18n } from '../i18n/index.jsx';

export default function BackButton({ to, label }) {
  const { setPage, pageHistory } = useApp();
  const { t } = useI18n();

  const goBack = () => {
    if (to) {
      setPage(to);
    } else if (pageHistory && pageHistory.length > 1) {
      // Go to previous page in history
      setPage(pageHistory[pageHistory.length - 2], true);
    } else {
      setPage('dashboard');
    }
  };

  return (
    <button
      onClick={goBack}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        background: 'rgba(255,255,255,0.08)',
        border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: 14,
        padding: '12px 20px',
        color: '#fff',
        cursor: 'pointer',
        marginBottom: 16,
        fontSize: 16,
        fontWeight: 600,
        transition: 'all 0.2s',
        WebkitTapHighlightColor: 'transparent',
      }}
    >
      <span style={{
        fontSize: 24,
        lineHeight: 1,
        display: 'flex',
        alignItems: 'center',
      }}>
        ‹
      </span>
      <span>{label || t('common.back')}</span>
    </button>
  );
}
